/**
 * JSX Dev Runtime implementation for JelenJS
 */
import { jsx, jsxs, Fragment } from './dom/jsx';

// Add development-specific JSX transform support
export const jsxDEV = jsx;
export { jsx, jsxs, Fragment }; 